// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_manage_token".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "appointment_manage_token" table (1:1 with a DB row, on the wire). */
export const appointmentManageTokenAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    appointmentId: z.string(),
    tokenHash: z.string(),
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentManageToken.js.map